export default class Service {
  constructor(props) {
    const constructor = {
      checked: 'isChecked',
      visible: 'isVisible',
      editable: 'isAvailable',
    }

    this.isChecked = props?.checked || false
    this.isVisible = props?.visible || true
    this.isAvailable = props?.editable || true

    Object.keys(props).forEach(option => {
      const key = constructor?.[option] || option

      this[key] = props[option]
    })
  }
}
